import { Journey } from 'modules/domains/campaign';
import { StyledNewTabLink } from './Sections.styled';

export const JOURNEY_LINK_ID = 'journey-link';

export const JourneyLink = ({ journey }: { journey: Journey }) => {
  return (
    <StyledNewTabLink
      data-test={JOURNEY_LINK_ID}
      href={`/workflows/${journey?.id}/edit?workflowType=${journey?.workflowType}`}
    >
      {journey?.name}
    </StyledNewTabLink>
  );
};
